export default [
  {
    path: "/blue-login",
    name: "blueLogin",
    component: () => import("@/views/blue/pages/login/index.vue"),
    meta: {
      title: "登陆",
    },
  },
  {
    path: "/blue-business-panel",
    name: "blueBusinessPanel",
    component: () => import("@/views/blue/pages/business-panel/index.vue"),
    meta: {
      title: "数据看板",
    },
  },
];
